import { includes, reduce } from "lodash";
import { Clause } from "@radarly/models/clause";
import { getFieldFromInnerClause } from "@radarly/models/clause/getter";
import { isSandboxedClause } from "@radarly/models/clause/is";
import {
  isCustomFieldsClause,
  isNotClause,
  isTermClause,
} from "@radarly/models/clause/is";
import { FullFacet, Value } from "@radarly/models/facets";

export function isIncludedFromFacet(
  clause: Clause,
  facet: FullFacet,
  value: string | number
) {
  return reduce(
    clause.and,
    (acc: boolean, innerClause) => {
      if (
        !isNotClause(innerClause) &&
        getFieldFromInnerClause(innerClause) === facet.id
      ) {
        if (isCustomFieldsClause(innerClause) && facet.custom) {
          return includes(innerClause.customFields[facet.id], value);
        } else if (isTermClause(innerClause)) {
          return includes(innerClause[facet.id], value);
        } else if (isSandboxedClause(innerClause)) {
          return innerClause[value];
        }
      }
      return acc;
    },
    false
  );
}

function isExcludedFromFacet(
  clause: Clause,
  facet: FullFacet,
  value: string | number
) {
  return reduce(
    clause.and,
    (acc: boolean, innerClause) => {
      if (
        isNotClause(innerClause) &&
        getFieldFromInnerClause(innerClause) === facet.id
      ) {
        if (isCustomFieldsClause(innerClause.not) && facet.custom) {
          return includes(innerClause.not.customFields[facet.id], value);
        } else if (isTermClause(innerClause.not)) {
          return includes(innerClause.not[facet.id], value);
        }
      } else if (isSandboxedClause(innerClause)) {
        return innerClause[value];
      }
      return acc;
    },
    false
  );
}

export function orderChoices(order: Value[]) {
  return reduce(
    order,
    (acc, val, i) => {
      acc[val.id] = i;
      return acc;
    },
    {}
  );
}

export function getStatus(
  id: string | number,
  clause: Clause,
  facet: FullFacet
) {
  if (isIncludedFromFacet(clause, facet, id)) return "include";
  if (isExcludedFromFacet(clause, facet, id)) return "exclude";
  return "none";
}
